export interface Leader {
  name: string;
  position: string;
  education: string;
  previousRoles: string[];
  background: string;
  image: string;
  alt: string;
  linkedin?: string;
  expertise: string[];
  bio: string;
  achievements: string[];
  quote?: string;
}

export const leaders: Leader[] = [
  // Kefa Kihara
  {
    name: 'Kefa Kihara',
    position: 'Founder',
    education: 'PhD Sustainable Development, Cambridge | MPA Public Policy, Princeton',
    previousRoles: [
      'Director of Impact Investing, UN Development Programme',
      'Senior Advisor, Global Impact Investing Network (GIIN)',
      'Sustainability Lead, Standard Bank (Africa)',
    ],
    background:
      'Aviation operations leader with military, commercial, and humanitarian experience.',
    image: '/assets/images/kefa-kihara.png',
    alt: 'Experienced African aviation executive in professional attire with confident expression',
    linkedin: '',
    expertise: [
      'Flight Operations Management',
      'Pilot Training and Development',
      'Aviation Safety & Compliance',
      'Aircraft Acquisition & Fleet Management',
      'Executive Leadership in Aviation',
      'Instrument Rating & Check Pilot Expertise',
    ],
    bio: 'Major Kefa Kihara (RTD) is the Director of Flight Operations at AMREF Flying Doctors, a role he assumed on May 1, 2023. He brings over 33 years of experience spanning military, commercial, and humanitarian aviation, and has played a pivotal role in strengthening flight safety, operational excellence, and pilot development within the organisation.',
    achievements: [
      'Director of Flight Operations at AMREF Flying Doctors since May 2023',
      'Over 33 years of experience in military, commercial, and humanitarian aviation',
      'First Kenyan Chief Pilot at AMREF Flying Doctors',
      'Logged over 12,000 flight hours across diverse aircraft and missions',
    ],
    quote:
      'I believe true leadership is rooted in integrity, purpose, and the relentless pursuit of excellence.',
  },
  // Evah Kungu
  {
    name: 'Evah Kungu, MBA',
    position: 'Financial Planning & Analysis',
    education:
      'MBA Global Social Sustainable Enterprise, USIU-Africa | BBA Finance, USIU-Africa | Diploma in Business Management, Strathmore University',
    previousRoles: [
      'Co-Founder, Realm Business Consulting (2022 - Present)',
      'Startup Funding Consultant and Business Writer',
    ],
    background:
      'Seasoned business consultant with extensive experience in developing business plans, pitch decks, and financial models for startups and established ventures across Kenya and Africa.',
    image: '/assets/images/evah-kungu.png',
    alt: 'Professional African female business consultant smiling confidently in office setting',
    linkedin: '',
    expertise: [
      'Startup Funding & Capital Raising',
      'Financial Modeling & Forecasting',
      'Business Plan Development',
      'Pitch Deck Creation',
      'Strategic Business Consulting',
      'Investor Relations & Document Review',
    ],
    bio: 'Evah Kungu is a seasoned Business Consultant and Co-Founder of Realm Business Consulting. She helps startups and established ventures craft compelling business materials, secure funding, and navigate complex business landscapes. With a track record of raising over $50 million through her documents, Evah empowers entrepreneurs to transform their vision into strategic success.',
    achievements: [
      'Raised over $50 million through equity, debt, and mezzanine documents',
      'Crafted over 100 pitch decks and 200 business plans',
      'Developed over 100 financial models and 200 financial forecasts from scratch',
      'Reviewed over 50 investor documents meticulously',
      'High-ranking consultant on Upwork in Pitch Decks and Business Plans',
    ],
    quote:
      'I empower entrepreneurs to translate vision into actionable, funding-ready business strategies.',
  },
  // Caroline Gathoni
  {
    name: 'Caroline Gathoni',
    position: 'Admin & Operations',
    education:
      "Master of International Relations (IR), United States International University - Africa (2023 - 2025) | Bachelor of Public Relations/Image Management, St. Paul's University (2016 - 2020)",
    previousRoles: [
      'Business Development and Customer Service Executive, AMREF Flying Doctors (2021 - Present)',
      'Customer Service Executive, AMREF Flying Doctors (2015 - 2020)',
    ],
    background:
      'Results-driven Business Development and Customer Service professional with extensive experience in revenue growth, client relationship management, and strategic market development within the aviation and healthcare sector. Combines strong communication, international relations expertise, and sales leadership to drive sustainable business performance.',
    image: '/assets/images/caroline-gathoni.png',
    alt: 'Professional African female corporate executive in a formal business setting',
    linkedin: '',
    expertise: [
      'Business Development & Revenue Growth',
      'Corporate Communication & Public Relations',
      'International Relations & Market Expansion',
      'Customer Experience Management',
      'Sales Strategy & Pipeline Development',
      'Key Account Management',
      'Team Collaboration & Performance Reporting',
    ],
    bio: 'Caroline Gathoni is a dynamic Business Development and Customer Service Executive with over a decade of experience at AMREF Flying Doctors. She specializes in building strong client relationships, expanding market presence, and delivering measurable revenue growth. With academic grounding in Public Relations and International Relations, Caroline integrates strategic communication, global market awareness, and customer-first leadership to create impactful business outcomes.',
    achievements: [
      'Over 10 years of progressive experience in customer service and business development',
      'Led revenue growth initiatives through strategic client acquisition and retention',
      'Managed and expanded key accounts across diverse markets',
      'Delivered consistent sales pipeline reporting and performance tracking',
      'Strengthened industry networks to maximize business opportunities',
    ],
    quote:
      'I combine strategic communication, relationship management, and data-driven execution to deliver sustainable business growth.',
  },
  // Nicole Kihara
  
  // Denis Muthuri
  {
    name: 'Denis Muthuri',
    position: 'Software Engineer',
    education:
      'Bachelor’s Degree in Information Systems & Technology, United States International University - Africa (2024 - 2028) | Computer Software Engineering, Moringa School (2024) | Diploma in Architecture, Kenya Institute of Highways and Building Technology (2018 - 2021) | High School Diploma, Mang’u High School | Primary School Certificate, Kathigiri Boarding Primary School',
    previousRoles: [
      'Software Engineer, AMREF Flying Doctors (2025 - Present)',
      'Information Technology Service Desk, Amref Health Africa (Apr 2025 - May 2025)',
      'Architectural Technician, Pronak Construction Limited (2019 - Present)',
      'Professional Photographer, The Mechanic Photography Studio (2018 - Present)',
      'Architectural Technician, Unlimited Design Studio (Aug 2018 - Dec 2018)',
      'Freelance Architectural Technician (2019 - 2024)',
    ],
    background:
      'Multidisciplinary technology professional with experience in software engineering, system development, IT support, architecture, and digital content creation. Combines technical problem-solving skills with system integration expertise and creative execution to build scalable solutions across web, CRM, and enterprise platforms.',
    image: '/assets/images/denis-muthuri.png',
    alt: 'Professional software engineer and technical professional in a modern workspace',
    linkedin: '',
    expertise: [
      'Web Application Development',
      'Microsoft Power Platform & Dynamics 365',
      'Power Apps & Power Automate Development',
      'CRM Customization & System Integration',
      'Database Design & Dataverse Management',
      'API Development & System Integration',
      'IT Support & Infrastructure Management',
      'Architectural Design & CAD Modeling',
      'Professional Photography & Digital Content Production',
    ],
    bio: 'Denis Muthuri is a Software Engineer with hands-on experience in enterprise application development, CRM customization, and digital system integration at AMREF Flying Doctors. With a strong background in information systems, architecture, and creative production, he builds scalable technical solutions while maintaining high standards of performance, reliability, and user experience.',
    achievements: [
      'Developed and customized enterprise applications using Microsoft Power Platform',
      'Implemented CRM workflows, automation, and system integrations',
      'Provided IT support and system troubleshooting for enterprise environments',
      'Designed architectural plans and digital models for commercial and residential projects',
      'Built professional creative portfolios through high-quality photography production',
    ],
    quote:
      'I build technology solutions that bridge systems, automate processes, and deliver measurable impact through clean architecture and efficient execution.',
  },
];
